/*@ngInject*/
const ResolveModalController = function ($rootScope, $scope, options, localization, coreConstant) {

    localization.getTranslations().then(function (result) {
        this.translations = result;
        $scope.saveButton = _.get(this.translations, 'homePage.widgets.taskGrid.resolveButton');
        $scope.cancelButton = _.get(this.translations, 'homePage.widgets.taskGrid.cancel');
    }.bind(this));

    $scope.title = options.title;
    $scope.summary = options.summary;
    $scope.resolutionNotes = '';

    $scope.onConfirm = function () {
        $scope.$close($scope.resolutionNotes);
    };

    $scope.onChange = function (resolutionNotes) {
        $scope.resolutionNotes = resolutionNotes;
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umLanding')
    .controller('resolveModalController', ResolveModalController);
